// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2qvaQ","content":"GlobalSearch_content__3sQuX"};